import React from "react";
import { useSelector, useDispatch, connect } from "react-redux";
import * as actionTypes from "../../../store/actions/actionTypes";
import { NavLink, Route } from "react-router-dom";

import ShopsRequest from "./ShopsRequest";
import ActiveShops from "./ActiveShops";
import BlockShops from "./BlockShops";
import SubscriptionOffShops from "./SubscriptionOffShops";

import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 5px;
`;
const DefaultNav = styled.div`
  width: 100%;
  height: 42px;
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
`;
const NavItem = styled(NavLink)`
  display: block;
  width: 22%;
  background: white;
  padding: 7px 0;
  font-weight: 500;
  color: white;
  text-decoration: none;
  text-align: center;
  border-radius: 5px;
  color: black;
`;
const Body = styled.div`
  width: 100%;
  height: 87%;
  margin-top: 30px;
  overflow-y: scroll;
`;
const Shops = (props) => {
  var date = new Date();

  var finalDate =
    date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
  return (
    <Container>
      <DefaultNav>
        <NavItem
          to="/admin/shops"
          exact
          activeStyle={{ background: "#FF5D5D", color: "white" }}
        >
          Shop Requests ({props.adminHome.requestedShops})
        </NavItem>
        <NavItem
          to="/admin/shops/active-shops"
          activeStyle={{ background: "#FF5D5D", color: "white" }}
        >
          Active Shops ({props.adminHome.activeShops})
        </NavItem>
        <NavItem
          to="/admin/shops/pause-shops"
          activeStyle={{ background: "#FF5D5D", color: "white" }}
        >
          Subscription Off ({props.adminHome.subOfShops})
        </NavItem>
        <NavItem
          to="/admin/shops/block-shops"
          activeStyle={{ background: "#FF5D5D", color: "white" }}
        >
          Blocked Shops ({props.adminHome.blcokedShops})
        </NavItem>
      </DefaultNav>

      <Body>
        <Route path="/admin/shops" exact component={ShopsRequest} />
        <Route path="/admin/shops/active-shops" exact component={ActiveShops} />
        <Route path="/admin/shops/block-shops" exact component={BlockShops} />
        <Route
          path="/admin/shops/pause-shops"
          exact
          component={SubscriptionOffShops}
        />
      </Body>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    adminHome: state.utils.adminHome,
  };
};

export default connect(mapStateToProps)(Shops);
